import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import appointmentReducer from "./slices/appointmentSlice";
import authReducer from "./slices/authSlice";
import themeReducer from "./slices/themeSlice";

// const persistConfig = {
//   key: "root",
//   storage,
//   whitelist: ["theme", "auth"],
// };

const authPersistConfig = {
  key: "auth",
  storage,
};

const themePersistConfig = {
  key: "theme",
  storage,
};

const persistedThemeReducer = persistReducer(themePersistConfig, themeReducer);
const persistedAuthReducer = persistReducer(authPersistConfig, authReducer);

// const persistedThemeReducer = persistReducer(persistConfig, themeReducer);
// const persistedAuthReducer = persistReducer(persistConfig, authReducer);

export const store = configureStore({
  reducer: {
    theme: persistedThemeReducer,
    auth: persistedAuthReducer,
    appointments: appointmentReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
